/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormualrioBancoCV from './controladorVista/formularioBancoCV';
import TablaBancoCV from './controladorVista/tablaBancoCV';
import { estadoIncial, reductor } from './reductorBanco';

const Banco: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaBancoCV />
        <FormualrioBancoCV />
    </ProveedorEstado>
);

export default Banco;
